module.exports = __webpack_public_path__ + "img/five_bg_boby.68895313.png";